module.exports = __webpack_public_path__ + "static/maceio-141a036a22e1e114f97e3cf3f3321f73.png";